import { createIcon } from '@chakra-ui/icons'
import React from 'react'
export const IconBookmark = createIcon({
  displayName: 'IconBookmark',
  path: [
    <path
      key="0"
      d="M20 22.94L12 17.23L4 22.94V2H20V4H6V19.06L12 14.77L18 19.06V6H20V22.94Z"
      fill="currentColor"
    />,
  ],
  viewBox: '0 0 24 24',
})
